var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 28.3945,
    r: 2.44731,
    transform: "rotate(-90 3.19731 28.3945)",
    fill: "#136F96",
    fillOpacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 15.4999,
    r: 2.44731,
    transform: "rotate(-90 3.19731 15.4999)",
    fill: "#136F96",
    fillOpacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19731,
    cy: 2.60524,
    r: 2.44731,
    transform: "rotate(-90 3.19731 2.60524)",
    fill: "#136F96",
    fillOpacity: 0.35
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0918,
    cy: 28.3945,
    r: 2.44731,
    transform: "rotate(-90 23.0918 28.3945)",
    fill: "#136F96",
    fillOpacity: 0.35
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0918,
    cy: 15.4999,
    r: 2.44731,
    transform: "rotate(-90 23.0918 15.4999)",
    fill: "#136F96",
    fillOpacity: 0.35
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0918,
    cy: 2.60524,
    r: 2.44731,
    transform: "rotate(-90 23.0918 2.60524)",
    fill: "#136F96",
    fillOpacity: 0.35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9864,
    cy: 28.3945,
    r: 2.44731,
    transform: "rotate(-90 42.9864 28.3945)",
    fill: "#136F96",
    fillOpacity: 0.35
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9864,
    cy: 15.4999,
    r: 2.44731,
    transform: "rotate(-90 42.9864 15.4999)",
    fill: "#136F96",
    fillOpacity: 0.35
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.9864,
    cy: 2.60524,
    r: 2.44731,
    transform: "rotate(-90 42.9864 2.60524)",
    fill: "#136F96",
    fillOpacity: 0.35
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtDots);
export default __webpack_public_path__ + "static/media/btDots.b747ec3f2ffe303525967ccf82c1462e.svg";
export { ForwardRef as ReactComponent };